import { render, staticRenderFns } from "./ListagemMenuXPerfilComponent.vue?vue&type=template&id=f7dc9b20"
import script from "./ListagemMenuXPerfilComponent.vue?vue&type=script&lang=js"
export * from "./ListagemMenuXPerfilComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports